import { ActivityLogOperationTypeEnum } from '../enums/ActivityLogOperationTypeEnum';
import { ActivityLogTargetTypeEnum } from '../enums/ActivityLogTargetTypeEnum';
import type ActivityLogGroupedType from '../interfaces/ActivityLogGroupedType';
import { translate } from '../utils/translation';

export const activityLogGroupedTargetOperationTypes: ActivityLogGroupedType[] = [
  {
    title: translate('activityLogTargetTypes.File'),
    value: ActivityLogTargetTypeEnum.File.toString(),
    children: [
      {
        title: translate('activityLogOperationTypes.CreateFile'),
        value: ActivityLogOperationTypeEnum.CreateFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ReadFile'),
        value: ActivityLogOperationTypeEnum.ReadFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DownloadFile'),
        value: ActivityLogOperationTypeEnum.DownloadFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DownloadFileEncrypted'),
        value: ActivityLogOperationTypeEnum.DownloadFileEncrypted.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DownloadFileZip'),
        value: ActivityLogOperationTypeEnum.DownloadFileZip.toString(),
      },
      {
        title: translate('activityLogOperationTypes.RenameFile'),
        value: ActivityLogOperationTypeEnum.RenameFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.MoveFile'),
        value: ActivityLogOperationTypeEnum.MoveFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DuplicateFile'),
        value: ActivityLogOperationTypeEnum.DuplicateFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.UploadFile'),
        value: ActivityLogOperationTypeEnum.UploadFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DeleteFileToRecycleBin'),
        value: ActivityLogOperationTypeEnum.DeleteFileToRecycleBin.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DeleteFilePermanently'),
        value: ActivityLogOperationTypeEnum.DeleteFilePermanently.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ShareFile'),
        value: ActivityLogOperationTypeEnum.ShareFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.PreviewFile'),
        value: ActivityLogOperationTypeEnum.PreviewFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.HiddenFile'),
        value: ActivityLogOperationTypeEnum.HiddenFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.UnhiddenFile'),
        value: ActivityLogOperationTypeEnum.UnhiddenFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.AddToFavorites'),
        value: ActivityLogOperationTypeEnum.AddToFavorites.toString(),
      },
      {
        title: translate('activityLogOperationTypes.RemoveFromFavorites'),
        value: ActivityLogOperationTypeEnum.RemoveFromFavorites.toString(),
      },

      {
        title: translate('activityLogOperationTypes.RestoreFile'),
        value: ActivityLogOperationTypeEnum.RestoreFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.MergeFiles'),
        value: ActivityLogOperationTypeEnum.MergeFiles.toString(),
      },
      {
        title: translate('activityLogOperationTypes.SplitFile'),
        value: ActivityLogOperationTypeEnum.SplitFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.LockFile'),
        value: ActivityLogOperationTypeEnum.LockFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.UnlockFile'),
        value: ActivityLogOperationTypeEnum.UnlockFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.Synchronize'),
        value: ActivityLogOperationTypeEnum.Synchronize.toString(),
      },
      {
        title: translate('activityLogOperationTypes.TagFile'),
        value: ActivityLogOperationTypeEnum.TagFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.RemoveTagFile'),
        value: ActivityLogOperationTypeEnum.RemoveTagFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.EncryptFile'),
        value: ActivityLogOperationTypeEnum.EncryptFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DecryptFile'),
        value: ActivityLogOperationTypeEnum.DecryptFile.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ChangeFileOwner'),
        value: ActivityLogOperationTypeEnum.ChangeFileOwner.toString(),
      },
      {
        title: translate('activityLogOperationTypes.SetFileExpiration'),
        value: ActivityLogOperationTypeEnum.SetFileExpiration.toString(),
      },
      {
        title: translate('activityLogOperationTypes.GenerateShareLink'),
        value: ActivityLogOperationTypeEnum.GenerateShareLink.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ShortCut'),
        value: ActivityLogOperationTypeEnum.ShortCut.toString(),
      },
    ],
  },
  {
    title: translate('activityLogTargetTypes.Folder'),
    value: ActivityLogTargetTypeEnum.Folder.toString(),
    children: [
      {
        title: translate('activityLogOperationTypes.CreateFolder'),
        value: ActivityLogOperationTypeEnum.CreateFolder.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ReadFolder'),
        value: ActivityLogOperationTypeEnum.ReadFolder.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DeleteFolderToRecycleBin'),
        value: ActivityLogOperationTypeEnum.DeleteFolderToRecycleBin.toString(),
      },
      {
        title: translate('activityLogOperationTypes.DeleteFolderPermanently'),
        value: ActivityLogOperationTypeEnum.DeleteFolderPermanently.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ShareFolder'),
        value: ActivityLogOperationTypeEnum.ShareFolder.toString(),
      },
    ],
  },
  {
    title: translate('activityLogTargetTypes.User'),
    value: ActivityLogTargetTypeEnum.User.toString(),
    children: [
      {
        title: translate('activityLogOperationTypes.GrantAccess'),
        value: ActivityLogOperationTypeEnum.GrantAccess.toString(),
      },
      {
        title: translate('activityLogOperationTypes.CreateUser'),
        value: ActivityLogOperationTypeEnum.CreateUser.toString(),
      },
      {
        title: translate('activityLogOperationTypes.EditUser'),
        value: ActivityLogOperationTypeEnum.EditUser.toString(),
      },
      {
        title: translate('activityLogOperationTypes.RemoveUser'),
        value: ActivityLogOperationTypeEnum.RemoveUser.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ValidateUser'),
        value: ActivityLogOperationTypeEnum.ValidateUser.toString(),
      },
      {
        title: translate('activityLogOperationTypes.LogIn'),
        value: ActivityLogOperationTypeEnum.LogIn.toString(),
      },
      {
        title: translate('activityLogOperationTypes.LogOut'),
        value: ActivityLogOperationTypeEnum.LogOut.toString(),
      },
      {
        title: translate('activityLogOperationTypes.OTPRequest'),
        value: ActivityLogOperationTypeEnum.OTPRequest.toString(),
      },
    ],
  },
  {
    title: translate('activityLogTargetTypes.Group'),
    value: ActivityLogTargetTypeEnum.Group.toString(),
    children: [
      {
        title: translate('activityLogOperationTypes.CreateGroup'),
        value: ActivityLogOperationTypeEnum.CreateGroup.toString(),
      },
      {
        title: translate('activityLogOperationTypes.EditGroup'),
        value: ActivityLogOperationTypeEnum.EditGroup.toString(),
      },
      {
        title: translate('activityLogOperationTypes.RemoveGroup'),
        value: ActivityLogOperationTypeEnum.RemoveGroup.toString(),
      },
    ],
  },
  {
    title: translate('activityLogTargetTypes.FilesFoldersAndTags'),
    value: ActivityLogTargetTypeEnum.FilesFoldersAndTags.toString(),
    children: [
      {
        title: translate('activityLogOperationTypes.SearchFiles'),
        value: ActivityLogOperationTypeEnum.SearchFiles.toString(),
      },
    ],
  },
  {
    title: translate('activityLogTargetTypes.Tag'),
    value: ActivityLogTargetTypeEnum.Tag.toString(),
    children: [
      {
        title: translate('activityLogOperationTypes.AddTag'),
        value: ActivityLogOperationTypeEnum.AddTag.toString(),
      },
      {
        title: translate('activityLogOperationTypes.RemoveTag'),
        value: ActivityLogOperationTypeEnum.RemoveTag.toString(),
      },
      {
        title: translate('activityLogOperationTypes.UpdateTag'),
        value: ActivityLogOperationTypeEnum.UpdateTag.toString(),
      },
      {
        title: translate('activityLogOperationTypes.ListTags'),
        value: ActivityLogOperationTypeEnum.ListTags.toString(),
      },
    ],
  },
];
